'use strict';

var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');
var validator = require('validator');
var Radio = require('backbone.radio');

require('intl-tel-input/build/js/utils');
require('intl-tel-input/build/js/intlTelInput.min');

var FormView = require('../form').default;
var AttendeeView = require('./attendee').default;
var polyglot = require('../../utilities/polyglot').default;
var Tracker = require('../../../analytics/events').default;
var AttendeeResponsesView = require('../responses/attendee-responses').default;

export default FormView.extend({

  className: 'form attendee-form',
  template: require('./templates/attendee-form.hbs'),
  regions: {
    buttons: '.form-buttons',
    questions: '.l-attendee-form-questions',
  },
  events: {
    'change #attendee-country': 'resetProvinceState',
    'change #attendee-receive_sms': 'trackCheckbox',
    'click .cancel-button': 'onClickCancel',
  },
  ui: {
    first_name: '#attendee-first-name',
    last_name: '#attendee-last-name',
    email: '#attendee-email',
    address: '#attendee-address',
    city: '#attendee-city',
    prov_state: '#attendee-prov-state',
    zip_postal: '#attendee-zip-postal',
    country: '#attendee-country',
    cell_phone: '#attendee-cell-phone',
    home_phone: '#attendee-home-phone',
    work_phone: '#attendee-work-phone',
    receive_sms: '#attendee-receive_sms',
  },
  submit: {
    className: 'button full',
    text: (polyglot.t('forms.attendees.save')),
  },

  initialize: function (options) {
    this.detailsView = options.parentView;
    this.attendeeView = options.attendeeView;
    this.clients = options.parentView.clients;
    this.responses = this.model.attendeeResponses;
  },

  showFields: function () {
    this.getRegion('questions').show(new AttendeeResponsesView({
      model: this.model,
      collection: this.responses,
      client: this.attendeeView ? this.attendeeView.client : null,
    }));
  },

  serializeData: function () {
    var json = this.model.toJSON();
    json = this.setClientFieldConditionals(json);

    if (this.responses) {
      json.responses = this.responses.toJSON();
    }

    return json;
  },

  renderIntlTelInputs: function () {
    var inputs = [this.ui.cell_phone, this.ui.home_phone, this.ui.work_phone];

    inputs.forEach((input) => {
      if (input.length > 0) {
        input.intlTelInput({
          nationalMode:   true,
          initialCountry: 'auto',
          geoIpLookup:    function(callback) {
            $.get('https://ipinfo.io', function() {}, 'jsonp').always(function(resp) {
              var countryCode = (resp && resp.country) ? resp.country : 'US';
              callback(countryCode);
            });
          },
        });
      }
    });
  },

  setClientFieldConditionals: function (json) {
    json.showLocationInformation = this.model.showLocationInformation();
    json.isLocationInformationRequired = this.model.isLocationInformationRequired();
    json.showHomePhone = this.model.showHomePhone();
    json.showMobilePhone = this.model.showMobilePhone();
    json.isHomePhoneRequired = this.model.isHomePhoneRequired();
    json.isMobilePhoneRequired = this.model.isMobilePhoneRequired();
    json.showWorkPhone = this.model.showWorkPhone();
    json.isWorkPhoneRequired = this.model.isWorkPhoneRequired();
    json.showSmsBox = window.SETTINGS.auto_sms_opt_in ? false : this.model.isSmsEnabled();
    json.showHomeWorkPhones = this.model.showHomePhone() || this.model.showWorkPhone();
    json.client = this.attendeeView ? this.attendeeView.client.attributes : false;

    return json;
  },

  onSubmit: function () {
    const isEditing = Boolean(this.attendeeView);

    this.hideErrors();

    if (!this.isValidAttendee()) {
      this.showErrors();
      Radio.channel('toast').trigger('show', {
        message: polyglot.t('forms.error'),
        iconColor: 'error',
      });

      return;
    }

    if (!isEditing && this.isDuplicateAttendee()) {
      Radio.channel('toast').trigger('show', {
        message: polyglot.t('forms.attendees.duplicate'),
        iconColor: 'error',
      });

      return;
    }

    const client = this.makeModel();
    if (this.model.has('attendeeAnswers')) {
      const answers = this.model.get('attendeeAnswers');
      client.set('answers', Object.keys(answers).length ? answers : {});
    }

    if (!this.isValidResponses(client)) {
      this.showErrors();
      Radio.channel('toast').trigger('show', {
        message: polyglot.t('forms.error'),
        iconColor: 'error',
      });

      return;
    }

    isEditing ? this.editAttendee(client) : this.addAttendee(client);

    let limit = window.SETTINGS.multiple_attendees_limit;
    if (this.model.isGroup()) {
      limit = this.model.get('attendee_limit')
              // - 1 is to account for the main attendee contributing to the attendee count
              ? this.model.get('attendee_limit') - this.model.get('attendee_count') - 1
              : null;
    }

    if (limit && this.clients.length >= limit) {
      $('.add-attendee').prop('disabled', 'disabled');
    }

    this.onCloseModal();
  },

  addAttendee: function (client) {
    this.clients.add(client);

    const attendeeView = new AttendeeView({
      client,
      clients: this.clients,
      appointment: this.model,
    });
    $('#attendees-list').append(attendeeView.render().el);

    this.detailsView.createAttendeeEditListener(attendeeView);

    this.model.set('additionalClients', this.clients);
  },

  editAttendee: function (client) {
    const index = this.clients.indexOf(this.attendeeView.client);

    this.clients.remove(this.clients.at(index));
    this.clients.add(client, { at: index });

    this.attendeeView.client = client;
    $('.attendee-list-item')[index] = this.attendeeView.render().el;

    this.detailsView.createAttendeeEditListener(this.attendeeView);

    this.model.set('additionalClients', this.clients);
  },

  makeModel: function () {
    var client = {
      id: null,
      first_name: this.ui.first_name.val(),
      last_name: this.ui.last_name.val(),
      email: this.ui.email.val(),
      lang: !!$('html').attr('lang') ? $('html').attr('lang') : 'en',
      receive_sms: window.SETTINGS.auto_sms_opt_in || this.ui.receive_sms.prop('checked'),
    };

    if (this.model.showHomePhone()) {
      client.phone = this.ui.home_phone.intlTelInput('getNumber');
    }

    if (this.model.showMobilePhone()) {
      client.cell_phone = this.ui.cell_phone.intlTelInput('getNumber');
    }

    if (this.model.showWorkPhone()) {
      client.work_phone = this.ui.work_phone.intlTelInput('getNumber');
    }

    if (this.model.showLocationInformation()) {
      client.address = this.ui.address.val();
      client.city = this.ui.city.val();
      client.zip_postal = this.ui.zip_postal.val();
      client.country = this.ui.country.val();
      client.prov_state = this.ui.prov_state.val();
    }

    return new Backbone.Model(client);
  },

  onClickCancel: function (event) {
    event.preventDefault();
    this.onCloseModal();
  },

  onCloseModal: function () {
    Radio.channel('modal').trigger('hide');
  },

  resetProvinceState: function () {
    this.clearProvinceStateOptions();

    if (this.ui.country.val() === 'US') {
      this.addStateOptions();
    } else if (this.ui.country.val() === 'CA') {
      this.addProvinceOptions();
    }
  },

  clearProvinceStateOptions: function () {
    this.ui.prov_state.html('');
    this.ui.prov_state.prop('disabled', true);
  },

  addStateOptions: function () {
    var self = this;
    var provState = this.attendeeView ? this.attendeeView.client.get('prov_state') : null;

    _.each(window.STATES, function (value, key) {
      self.ui.prov_state.append(self.addSelectOption(key, value, provState));
    });
    this.ui.prov_state.prop('disabled', false);
  },

  addProvinceOptions: function () {
    var self = this;
    var provState = this.attendeeView ? this.attendeeView.client.get('prov_state') : null;

    _.each(window.PROVINCES, function (value, key) {
      self.ui.prov_state.append(self.addSelectOption(key, value, provState));
    });
    this.ui.prov_state.prop('disabled', false);
  },

  addSelectOption: function (key, value, selectedVal) {
    var selected = selectedVal == key ? 'selected' : '';

    return "<option value='" + key + "' " + selected + ">" + value + "</option>";
  },

  initializeCountrySelect: function () {
    var self = this;
    var country = this.attendeeView ? this.attendeeView.client.get('country') : null;

    _.each(window.COUNTRIES, function (value, key) {
      self.ui.country.append(self.addSelectOption(key, value, country));
    });

    if (country === 'CA') {
      this.addProvinceOptions();
    } else if (country === 'US') {
      this.addStateOptions();
    } else {
      this.clearProvinceStateOptions();
    }
  },

  isValidAttendee: function () {
    const errors = {};
    const email = this.ui.email.val();
    const cellPhone = this.ui.cell_phone.val();
    const homePhone = this.ui.home_phone.val();
    const workPhone = this.ui.work_phone.val();
    const country = this.ui.country.val();

    if (!this.ui.first_name.val()) {
      errors.first_name = polyglot.t('forms.first_name.error');
    }

    if (!this.ui.last_name.val()) {
      errors.last_name = polyglot.t('forms.last_name.error');
    }

    if (!(email && validator.isEmail(email))) {
      errors.email = polyglot.t('forms.email.error');
    }

    if (this.model.isMobilePhoneRequired() && !cellPhone) {
      errors.cell_phone = polyglot.t('forms.cell_phone.error');
    }

    if (cellPhone && cellPhone.match(/[A-z]/g)) {
      errors.cell_phone = polyglot.t('forms.cell_phone.error');
    }

    if (this.model.isHomePhoneRequired() && !homePhone) {
      errors.home_phone = polyglot.t('forms.cell_phone.error');
    }

    if (homePhone && homePhone.match(/[A-z]/g)) {
      errors.home_phone = polyglot.t('forms.cell_phone.error');
    }

    if (this.model.isWorkPhoneRequired() && !workPhone) {
      errors.work_phone = polyglot.t('forms.cell_phone.error');
    }

    if (workPhone && workPhone.match(/[A-z]/g)) {
      errors.work_phone = polyglot.t('forms.cell_phone.error');
    }

    if (this.model.isLocationInformationRequired()) {
      if (!this.ui.address.val()) {
        errors.address = polyglot.t('forms.address.error');
      }

      if (!this.ui.city.val()) {
        errors.city = polyglot.t('forms.city.error');
      }

      if (!this.ui.zip_postal.val()) {
        errors.zip_postal = polyglot.t('forms.zip_postal.error');
      }

      if (!country) {
        errors.country = polyglot.t('forms.country.error');
      }

      //if the prov/state isn't set AND the country is set AND the country is USA OR Canada, set the error
      if (!this.ui.prov_state.val() && (country && (country == 'CA' || country == 'US'))) {
        errors.prov_state = polyglot.t('forms.prov_state.error');
      }
    }

    this.model.validationError = errors;

    return Object.keys(errors).length === 0;
  },

  isDuplicateAttendee: function () {
    const attendeeClients = this.clients;
    const firstName = this.ui.first_name.val().toLowerCase().trim();
    const lastName = this.ui.last_name.val().toLowerCase().trim();
    const email = this.ui.email.val().toLowerCase().trim();

    const mainFirstName = $('#first-name').val().trim();
    const mainLastName = $('#last-name').val().trim();
    const mainEmail = $('#email').val().trim();
    if (mainFirstName && mainLastName && mainEmail
        && mainFirstName.toLowerCase() === firstName
        && mainLastName.toLowerCase() === lastName
        && mainEmail.toLowerCase() === email) {
      return true;
    }

    const duplicates = attendeeClients.filter(client => (
      client.get('first_name').toLowerCase() === firstName
        && client.get('last_name').toLowerCase() === lastName
        && client.get('email').toLowerCase() === email
    ));

    return duplicates.length > 0;
  },

  isValidResponses: function (client) {
    const errors = {};

    if (_.size(this.responses) > 0) {
      var required = _.filter(this.responses.models, function (response) {
        return response.get('question').get('required');
      });

      if (_.size(required) > 0) {
        var answers = [];
        if (client.has('answers')) {
          answers = client.get('answers');
        }

        _.each(required, function (q) {
          var question = q.get('question');

          if (!answers[question.get('id')]) {
            errors[question.get('id')] = polyglot.t('forms.required.error');
          }
        });
      }
    }

    this.model.validationError = errors;

    return Object.keys(errors).length === 0;
  },

  trackCheckbox: function (e) {
    if (e.target.checked) {
      Tracker.trackEvent('Opt-In SMS', 'click', 'Checked');
    } else {
      Tracker.trackEvent('Opt-In SMS', 'click', 'Unchecked');
    }
  },
});
